export class DiscoveryJob {
    'runId';
    'startedAt';
    'finishedAt';
    'status';
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runId",
            "baseName": "runId",
            "type": "string",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "JobStatus",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DiscoveryJob.attributeTypeMap;
    }
    constructor() {
    }
}
